package org.gstechnovos.jexonplastech.sections.about.styles

import com.varabyte.kobweb.compose.css.Transition
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.modifiers.*
import com.varabyte.kobweb.silk.style.CssStyle
import com.varabyte.kobweb.silk.style.selectors.hover
import org.gstechnovos.jexonplastech.theme.toSitePalette
import org.jetbrains.compose.web.css.percent
import org.jetbrains.compose.web.css.px
import org.jetbrains.compose.web.css.s

val ExecutivesContainerStyle = CssStyle {
    val palette = colorMode.toSitePalette()
    base {
        Modifier
            .fillMaxWidth()
            .backgroundColor(palette.custom.white)
    }
}

val ExecutiveCardStyle = CssStyle {
    val palette = colorMode.toSitePalette()
    base {
        Modifier
            .fillMaxWidth()
            .padding(30.px)
            .backgroundColor(palette.custom.white)
            .borderRadius(16.px)
            .boxShadow(0.px, 10.px, 30.px, color = palette.custom.darkText.toRgb().copyf(alpha = 0.05f))
            .transition(
                Transition.of("transform", 0.3.s),
                Transition.of("box-shadow", 0.3.s)
            )
    }
    hover {
        Modifier
            .translateY((-10).px)
            .boxShadow(0.px, 20.px, 40.px, color = palette.custom.darkText.toRgb().copyf(alpha = 0.12f))
    }
}